import { render, staticRenderFns } from "./MnemonicTableToPrint.vue?vue&type=template&id=bfd854f0&scoped=true&"
import script from "./MnemonicTableToPrint.vue?vue&type=script&lang=js&"
export * from "./MnemonicTableToPrint.vue?vue&type=script&lang=js&"
import style0 from "./MnemonicTableToPrint.vue?vue&type=style&index=0&id=bfd854f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd854f0",
  null
  
)

export default component.exports